import React from 'react'

function Slider () {
  return (
    <section>
      <div class='container-fluid px-0'>
        <div
          id='carouselId'
          class='carousel slide'
          data-bs-ride='carousel'
          data-bs-interval='1000'
        >
          <div class='carousel-inner' role='listbox'>
            <div class='carousel-item'>
              <img
                src='project-pic/software.jpg'
                class='img-fluid'
                alt='First slide'
              />
              <div class='carousel-caption'>
                <div class='container carousel-content'>
                  <h1 class='text-white display-1 animated fadeInUp bannerh1'>
                    Software Engineering
                  </h1>
                  <p class='mb-4 text-white fs-5 animated fadeInDown bannerp'>
                    Rock-solid solution for a changing world.
                  </p>
                </div>
              </div>
            </div>
            <div class='carousel-item'>
              <img
                src='project-pic/bi.jpg'
                class='img-fluid'
                alt='Second slide'
              />
              <div class='carousel-caption'>
                <div class='container carousel-content'>
                  <h1 class='text-white8 display-1 mb-4 animated fadeInUp bannerh1'>
                    Business Intelligence
                  </h1>
                  <p class='mb-4 text-white fs-5 animated fadeInDown bannerp'>
                    Informed Intelligence on demand, Anywhere, EveryWhere
                  </p>
                </div>
              </div>
            </div>
            <div class='carousel-item active carousel-item-start'>
              <img
                src='project-pic/predictive.jpg'
                class='img-fluid'
                alt='Third slide'
              />
              <div class='carousel-caption'>
                <div class='container carousel-content'>
                  <h1 class='text-white display-1 mb-4 animated fadeInUp bannerh1'>
                    Predictive Analytics
                  </h1>
                  <p class='mb-4 text-white fs-5 animated fadeInDown bannerp'>
                    GSTS offers Prophecy, our flagship product for Predictive
                    Analytics.
                  </p>
                </div>
              </div>
            </div>
            <div class='carousel-item carousel-item-next carousel-item-start'>
              <img
                src='project-pic/modernization.jpg'
                class='img-fluid'
                alt='Fourth slide'
              />
              <div class='carousel-caption'>
                <div class='container carousel-content'>
                  <h1 class='text-white display-1 mb-4 animated fadeInUp bannerh1'>
                    Modernization
                  </h1>
                  <p class='mb-4 text-white fs-5 animated fadeInDown bannerp'>
                    Evolve, Innovate and dominate your market
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Slider
